module.exports = __webpack_public_path__ + "assets/img/0d6eff7f9e3ffc1c06a25f38bf8cd554.svg";